var map = {
	"./blender.png": 4950,
	"./dummy.png": 5751,
	"./grill.png": 6092,
	"./kochen.png": 4900,
	"./messer.png": 9867,
	"./nudelholz.png": 9508,
	"./ofen.png": 8909,
	"./pfanne.png": 639,
	"./schneebesen.png": 8143,
	"./topf.png": 9781,
	"./uhr.png": 402,
	"./waschen.png": 1431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4140;